"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUCCESS_MESSAGES = exports.ERROR_MESSAGES = exports.getWaitlistEnabled = exports.TEST_ACCOUNT_EMAILS = exports.FOUNDING_ADMIN_UIDS = exports.ACCESS_REQUEST_STATUS = exports.USER_ROLES = exports.SYSTEM_ACCOUNTS = exports.SUPPORTED_LANGUAGES = exports.RATING_SCALE = exports.INPUT_LIMITS = exports.THEME_MODES = exports.NOTIFICATION_TYPES = exports.PRIVACY_LEVELS = exports.WATCH_COMPANION_WATCHLIST_NAME = exports.DEFAULT_WATCHLISTS = exports.MOVIE_GENRES = exports.ACTIVITY_TYPES = exports.PRIVACY_SETTINGS = exports.MOVIE_STATUS = exports.COLLECTIONS = exports.APP_CONFIG = exports.TMDB_POSTER_SIZES = exports.TMDB_BACKDROP_BASE_URL = exports.TMDB_IMAGE_BASE_URL = exports.TMDB_BASE_URL = void 0;
const appConfig_1 = require("../services/appConfig");
// TMDB API Constants
exports.TMDB_BASE_URL = 'https://api.themoviedb.org/3';
exports.TMDB_IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500';
exports.TMDB_BACKDROP_BASE_URL = 'https://image.tmdb.org/t/p/w1280';
exports.TMDB_POSTER_SIZES = {
    small: 'w92',
    medium: 'w185',
    large: 'w342',
    xlarge: 'w500',
    original: 'original'
};
// App Configuration Constants
exports.APP_CONFIG = {
    MAX_RECENT_MOVIES: 10,
    MAX_RECENT_SEARCHES: 10,
    MAX_WATCHLIST_SIZE: 1000,
    MAX_CUSTOM_WATCHLIST_SIZE: 500,
    PAGINATION_SIZE: 20,
    SEARCH_DEBOUNCE_MS: 300,
    CACHE_EXPIRY_MS: 5 * 60 * 1000, // 5 minutes
};
// Firebase Collection Names
exports.COLLECTIONS = {
    USERS: 'users',
    USER_MOVIES: 'userMovies',
    USER_WATCHLISTS: 'userWatchlists',
    USER_ACTIVITIES: 'userActivity',
    USER_SEARCH_HISTORY: 'userSearchHistory',
    USER_RECENT_MOVIES: 'userRecentMovies',
    USER_RECENTLY_ADDED_MOVIES: 'userRecentlyAddedMovies',
    NOTIFICATIONS: 'notifications',
    COLLABORATION_REQUESTS: 'collaborationRequests',
    USER_FOLLOWING: 'userFollowing',
    USER_PROFILES: 'userProfiles',
    ACCESS_REQUESTS: 'accessRequests',
    /** Official Crew feed posts (moderator/admin authored; shown as Watchlist Crew) */
    CREW_POSTS: 'crewPosts',
};
// Movie Status Constants
exports.MOVIE_STATUS = {
    WANT_TO_WATCH: 'want_to_watch',
    WATCHED: 'watched',
    RATED: 'rated',
    REVIEWED: 'reviewed'
};
// Privacy Settings
exports.PRIVACY_SETTINGS = {
    ANYONE: 'anyone',
    ONLY_ME: 'only-me',
    FOLLOWERS: 'followers'
};
// Activity Types
exports.ACTIVITY_TYPES = {
    MOVIE_ADDED_TO_WATCHLIST: 'movie_added_to_watchlist',
    MOVIE_WATCHED: 'movie_watched',
    MOVIE_RATED: 'movie_rated',
    MOVIE_REVIEWED: 'movie_reviewed',
    WATCHLIST_CREATED: 'watchlist_created',
    WATCHLIST_SHARED: 'watchlist_shared',
    USER_FOLLOWED: 'user_followed'
};
// =============== MOVIE CONSTANTS ===============
// Movie genres mapping (TMDB genre IDs)
exports.MOVIE_GENRES = {
    ACTION: 28,
    ADVENTURE: 12,
    ANIMATION: 16,
    COMEDY: 35,
    CRIME: 80,
    DOCUMENTARY: 99,
    DRAMA: 18,
    FAMILY: 10751,
    FANTASY: 14,
    HISTORY: 36,
    HORROR: 27,
    MUSIC: 10402,
    MYSTERY: 9648,
    ROMANCE: 10749,
    SCIENCE_FICTION: 878,
    TV_MOVIE: 10770,
    THRILLER: 53,
    WAR: 10752,
    WESTERN: 37,
};
// Default watchlist names
exports.DEFAULT_WATCHLISTS = {
    MAIN: 'main-watchlist',
    WATCHED: 'watched',
    WANT_TO_WATCH: 'want-to-watch',
    /** Virtual id: resolved to Firestore doc via `userProfiles.watchCompanionWatchlistId` */
    APPLE_WATCH: 'apple-watch',
    YOUR_REVIEWS: 'your-reviews',
};
/** Display name for the Apple Watch companion list (shown in web/mobile UI). */
exports.WATCH_COMPANION_WATCHLIST_NAME = '\u231A\uFE0E Watch-list';
// =============== PRIVACY CONSTANTS ===============
exports.PRIVACY_LEVELS = {
    PUBLIC: 'public',
    FRIENDS: 'friends',
    PRIVATE: 'private',
    ANYONE: 'anyone',
    ONLY_ME: 'only-me',
};
// =============== NOTIFICATION CONSTANTS ===============
exports.NOTIFICATION_TYPES = {
    FOLLOW: 'follow',
    STARTED_FOLLOWING: 'started_following',
    COLLABORATION: 'collaboration',
    LIKE_WATCHLIST: 'like_watchlist',
    SHARE_WATCHLIST: 'share_watchlist',
    SHARE_MOVIE: 'share_movie',
    SHARE_PROFILE: 'share_profile',
    SHARE_PERSON: 'share_person',
    MOVIE_ADDED: 'movie_added',
    COLLABORATOR_ADDED: 'collaborator_added',
    MOVIE_WATCHED: 'movie_watched',
    USER_FOLLOWED: 'user_followed',
    WATCHLIST_LIKED: 'watchlist_liked',
    COLLABORATION_INVITATION: 'collaboration_invitation',
};
// =============== THEME CONSTANTS ===============
exports.THEME_MODES = {
    LIGHT: 'light',
    DARK: 'dark',
    SYSTEM: 'system',
};
// =============== VALIDATION CONSTANTS ===============
// Input limits
exports.INPUT_LIMITS = {
    USERNAME_MIN: 3,
    USERNAME_MAX: 20,
    BIO_MAX: 500,
    REVIEW_MAX: 2000,
    WATCHLIST_NAME_MAX: 50,
    WATCHLIST_DESCRIPTION_MAX: 500,
    NOTE_MAX: 1000,
};
// Rating scale
exports.RATING_SCALE = {
    MIN: 0.5,
    MAX: 5,
    STEP: 0.5,
};
// =============== LANGUAGE CONSTANTS ===============
exports.SUPPORTED_LANGUAGES = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'es', name: 'Spanish', nativeName: 'Español' },
    { code: 'fr', name: 'French', nativeName: 'Français' },
    { code: 'de', name: 'German', nativeName: 'Deutsch' },
    { code: 'it', name: 'Italian', nativeName: 'Italiano' },
    { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
    { code: 'ja', name: 'Japanese', nativeName: '日本語' },
    { code: 'ko', name: 'Korean', nativeName: '한국어' },
    { code: 'zh', name: 'Chinese', nativeName: '中文' },
    { code: 'ru', name: 'Russian', nativeName: 'Русский' },
    { code: 'ar', name: 'Arabic', nativeName: 'العربية' },
    { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी' },
];
// =============== SYSTEM ACCOUNTS ===============
// Official Watchlist Crew account that all new users should follow
exports.SYSTEM_ACCOUNTS = {
    WATCHLIST_CREW_UID: 'd8zyoVABvSVXr5c7fMldLS2oNcK2', // Replace with actual UID
};
// =============== ACCESS CONTROL ===============
// User roles for access control
exports.USER_ROLES = {
    ADMIN: 'admin',
    MODERATOR: 'moderator',
    TEST: 'test',
    REGULAR: 'regular',
    PENDING: 'pending',
};
// Access request statuses
exports.ACCESS_REQUEST_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
// Founding admin UIDs - these users are always admins and cannot be demoted
// Add your Firebase Auth UID here after deploying
exports.FOUNDING_ADMIN_UIDS = [
    "d8zyoVABvSVXr5c7fMldLS2oNcK2", "3RcCTh2Rl7eJczVLIrYWPJVzz7J3"
];
// Test account for App Store / Play Store review
// These accounts bypass the waitlist and get instant access
exports.TEST_ACCOUNT_EMAILS = [
    'applereview@watchlists.app',
    'playreview@watchlists.app',
    'testreview@watchlists.app',
];
// Feature flag: controlled via Remote Config 'feature_waitlist_enabled'.
// When false, new users get REGULAR role immediately. When true, new users are PENDING until approved.
const getWaitlistEnabled = () => (0, appConfig_1.getAppConfig)().featureWaitlistEnabled;
exports.getWaitlistEnabled = getWaitlistEnabled;
// =============== ERROR MESSAGES ===============
exports.ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error. Please check your connection.',
    PERMISSION_DENIED: 'You don\'t have permission to perform this action.',
    NOT_FOUND: 'The requested resource was not found.',
    INVALID_INPUT: 'Please check your input and try again.',
    RATE_LIMIT: 'Too many requests. Please try again later.',
    SERVER_ERROR: 'Server error. Please try again later.',
    AUTH_REQUIRED: 'Please sign in to continue.',
    INVALID_API_KEY: 'Invalid API key. Please contact support.',
};
// =============== SUCCESS MESSAGES ===============
exports.SUCCESS_MESSAGES = {
    MOVIE_ADDED: 'Movie added to watchlist',
    MOVIE_REMOVED: 'Movie removed from watchlist',
    MOVIE_WATCHED: 'Movie marked as watched',
    MOVIE_UNWATCHED: 'Movie unmarked as watched',
    REVIEW_SAVED: 'Review saved successfully',
    PROFILE_UPDATED: 'Profile updated successfully',
    SETTINGS_SAVED: 'Settings saved successfully',
    WATCHLIST_CREATED: 'Watchlist created successfully',
    WATCHLIST_DELETED: 'Watchlist deleted successfully',
};
